var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-container"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.company.logo,"alt":"Logo"}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }